import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import { t } from 'i18next';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useBlocks } from '../../../../hooks/flow/block/useBlocks';
import { useFlowActions } from '../../../../hooks/flow/flow/useFlowActions';
import { useModal } from '../../../../hooks/modal/useModal';

export const BlockTitleEditForm = () => {
  const { updateBlocks, setSelectedBlock } = useFlowActions();
  const { hideModal } = useModal();
  const { selectedBlock } = useBlocks();
  const { handleSubmit, control } = useForm({
    defaultValues: {
      blockTitle: selectedBlock?.blockTitle || selectedBlock?.id || '',
    },
    shouldUseNativeValidation: true,
  });

  const hideAndSubmit = useCallback(
    (data: { blockTitle?: string }) => {
      if (!selectedBlock) {
        return;
      }
      const { blockTitle } = data;
      const newBlock = { ...selectedBlock, blockTitle };
      updateBlocks([newBlock]);
      setSelectedBlock(newBlock);
      hideModal();
    },
    [selectedBlock, updateBlocks, setSelectedBlock, hideModal],
  );

  if (!selectedBlock) {
    return <></>;
  }

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <InputWithLabelT
          type='text'
          field='blockTitle'
          label={t('flow.blocks.block-title')}
          placeholder={t('flow.blocks.block-title')}
          id='blockTitle'
          control={control}
          options={{
            required: t('general.validation.required'),
          }}
        />
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};
